module.exports = __webpack_public_path__ + "static/media/JPY.11377cbd.svg";